import { useAnalyticContext } from '@application/analytic/analytic_link/mod';
import { withTranslation } from '@application/i18n/with_translation';
import { Button, ButtonArrange, Flex, Spacer } from '@cellula/react';
import { tokens } from '@cellula/react-theme-patient';
import { Illustration } from '@component/illustration/mod';
import { Title } from '@component/title.component';
import { TopBar } from '@component/top_bar.component';
import { useResolveController } from '@visiba/instantiation';
import { useEffect } from 'react';
import styled from 'styled-components';
import { ViewRedRobinController } from '../view_red_robin.controller';

const elements = {
	container: styled(Flex)`
		text-align: center;
		max-width: 400px;
	`,
	illustration: styled(Illustration)`
		width: 200px;
		max-width: 100%;
	`,
};

export function ScreenError() {
	const controller = useResolveController(ViewRedRobinController);

	const analytics = useAnalyticContext();

	function handleRestart() {
		analytics.trackEvent('Clicked error page button');
		controller.goToReceptionHome();
	}

	useEffect(
		function whenMounted() {
			analytics.service.trackPageView({
				customTitle: 'RedRobin: Error',
			});
		},
		[analytics],
	);

	return (
		<>
			<TopBar.Content onAbort={null} />
			<Flex gap={tokens.spacing.x4} grow={1} align='center' justify='center'>
				<elements.container align='center' gap={tokens.spacing.x2_5} grow={1}>
					<elements.illustration type='error' />
					<Title
						title={withTranslation('View.RedRobin.ErrorInterrupted.Title')}
						titleSize='small'
						description={withTranslation('View.RedRobin.ErrorInterrupted.Body')}
					/>
				</elements.container>
				<Flex style={{ width: '100%' }}>
					<ButtonArrange justify='center'>
						<Button variant='primary' onClick={handleRestart}>
							{withTranslation('View.RedRobin.ErrorInterrupted.Button')}
						</Button>
					</ButtonArrange>
				</Flex>
			</Flex>
			<Spacer vertical={tokens.spacing.x3} />
		</>
	);
}
